
import { ResourceFile } from "../types";
import { 
  isQuizFile, 
  isFreeResponseFile, 
  isDragDropFile, 
  isLinkingFile 
} from "../utils/fileTypeUtils";

export function useTrainingContentTypes(currentFile: ResourceFile | undefined) {
  // Determine content types
  const isQuizView = currentFile ? isQuizFile(currentFile) : false;
  const isFreeResponseView = currentFile ? isFreeResponseFile(currentFile) : false;
  const isDragDropView = currentFile ? isDragDropFile(currentFile) : false;
  const isLinkingView = currentFile ? isLinkingFile(currentFile) : false;
  
  return {
    isQuizView,
    isFreeResponseView,
    isDragDropView,
    isLinkingView
  };
}
